const styles = {
    modalContent: {
        minHeight: 450
    },
    modalAction: {
        marginTop: 20
    },
    icon: {
        marginLeft: 3
    },
    button: {
        marginRight: 'auto'
    }
};

export default styles;
